import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "parshhr_access_token";
const REFRESH_KEY = "parshhr_refresh_token";

export const tokenStore = {
    getAccess: () => localStorage.getItem(TOKEN_KEY),
    getRefresh: () => localStorage.getItem(REFRESH_KEY),
    set: (access, refresh) => {
        if (access) localStorage.setItem(TOKEN_KEY, access);
        if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
    },
    clear: () => {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(REFRESH_KEY);
    },
};

const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((config) => {
    const token = tokenStore.getAccess();
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

let refreshing = null;
api.interceptors.response.use(
    (r) => r,
    async (error) => {
        const orig = error.config;
        if (
            error.response?.status === 401 &&
            !orig._retry &&
            !orig.url?.includes("/auth/")
        ) {
            orig._retry = true;
            try {
                refreshing =
                    refreshing ||
                    axios.post(
                        `${API}/auth/refresh`,
                        { refresh_token: tokenStore.getRefresh() },
                        {
                            headers: tokenStore.getRefresh()
                                ? { Authorization: `Bearer ${tokenStore.getRefresh()}` }
                                : {},
                        },
                    );
                const r = await refreshing;
                refreshing = null;
                if (r?.data?.access_token) {
                    tokenStore.set(r.data.access_token, r.data.refresh_token);
                    orig.headers.Authorization = `Bearer ${r.data.access_token}`;
                }
                return api(orig);
            } catch (e) {
                refreshing = null;
                tokenStore.clear();
                return Promise.reject(e);
            }
        }
        return Promise.reject(error);
    },
);

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
